import "./Home.css";
import SearchComponent from "../components/Search";
import { FaPhoneAlt } from "react-icons/fa";
import { TfiTime } from "react-icons/tfi";
import { FaLocationDot } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import ModalComponent from "../components/ModalComponent";
import { ContactData } from "../data-types/api-client/api-contacts";
import AvailabilitySection from "../components/AvailabilitySection";
interface ContactProps {
  contact: ContactData | undefined; // Accept ContactData as a prop
}

const Home: React.FC<ContactProps> = ({ contact }) => {
  const numberOfProducts =
    contact?.productsCount && Math.floor(contact?.productsCount / 10) * 10;

  const navigate = useNavigate();

  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      {/* <SearchComponent onSearch={() => {}} /> */}

      {/* <div className="flex flex-col items-center justify-center h-full w-full md:px-18 sm:px-8 px-4 bg-custom-gray gap-4 lg:gap-0"> */}
      <div className="flex flex-col items-center justify-center h-full w-full justify-self-center pb-8 2xl:w-3/4 bg-custom-white">
        <div className="flex justify-center gap-2 lg:pt-8 pt-8 lg:pb-6 pb-4 lg:bg-custom-gray-100 flex-col items-center w-full">
          {" "}
          <h1 className="main-title">Požičovňa náradia</h1>
          <h2
            className="w-full text-center
    lg:bg-custom-transparent text-base md:text-2xl font-normal leading-[1.05] text-custom-blue/90"
          >
            Viac ako{" "}
            <span className="font-bold">
              {numberOfProducts && numberOfProducts}
              <span className="ml-1 font-bold">+</span>
            </span>{" "}
            produktov na požičanie
          </h2>
        </div>
        <div className="flex flex-col bg-custom-gray justify-self-center items-center h-full md:px-20 sm:px-8 px-4 w-full gap-3 py-0 pb-8">
          <div className="flex w-full justify-self-center items-center h-full w-full grid-row gap-8 md:py-7 py-0 grid lg:grid-cols-2 pb-6">
            {/* Left Side */}
            <div className="lg:gap-1 gap-4 flex h-full w-full flex-col items-center self-stretch">
              <div className="flex w-full flex-col bg-custom-white shadow-md rounded-lg gap-1 lg:px-4 py-8 justify-center lg:items-start items-center">
                {" "}
                <div className="flex justify-start items-center gap-2">
                  {" "}
                  <FaLocationDot className="text-custom-red lg:text-4xl text-3xl" />
                  <h2
                    className="uppercase sm:text-xl text-base tracking-wider text-center md:text-left text-custom-blue font-
              bold"
                  >
                    Výdajné miesto
                  </h2>
                </div>
                <div className="flex justify-center flex-col lg:pl-10 lg:items-start items-center w-full">
                  <p className="font-bold xl:text-5xl text-custom-blue lg:text-4xl sm:text-5xl text-3xl">
                    {contact?.contact.address.dispensingPoint}
                  </p>{" "}
                  <p
                    className="font-normal text-custom-blue/75
               text-lg text-center tracking-wider"
                  >
                    {contact?.contact.address.dispensingPointDetails}
                  </p>
                </div>
              </div>
              <div className="lg:mt-6 mt-0 w-full bg-custom-red-light/50 rounded-lg lg:px-6 px-4 lg:py-8 py-6">
                <div className="flex flex-col lg:items-start items-center lg:gap-6 gap-4 text-center lg:text-left">
                  <div className="flex gap-3 lg:gap-4 items-center justify-center">
                    {/* Icon container*/}
                    <div className="flex items-center justify-center">
                      {" "}
                      <div className="flex justify-center items-center p-3 bg-custom-white rounded-full">
                        {" "}
                        <TfiTime className="text-custom-red lg:text-4xl text-3xl" />
                      </div>
                    </div>

                    {/* Text container */}
                    <div className="flex flex-col text-left justify-center gap-1.5 items-start">
                      <h2 className="text-lg lg:text-xl uppercase font-semibold text-custom-red leading-normal">
                        Otvorené po dohode.
                      </h2>

                      <p className="text-base text-custom-blue leading-normal">
                        Prosím, kontaktujte nás vopred a dohodnite si čas
                        vyzdvihnutia.
                      </p>
                    </div>
                  </div>
                  {/* Contact Button Container */}
                  <div
                    className="flex justify-center
       items-center w-full"
                  >
                    {" "}
                    <a
                      href={`tel:${contact?.contact.mobileConsultancy}`}
                      className="
    lg:w-full
    md:w-96
    w-full
    group
    bg-custom-white
    md:hover:bg-custom-red
    border border-custom-red/30
    md:hover:border-custom-red
    rounded-lg
    shadow-md
    px-3
    py-2
    flex
    items-center
    justify-center
    transition-all
    duration-300
  "
                    >
                      <div
                        className="
      rounded-full
      bg-custom-red
      md:group-hover:bg-custom-white
      p-2
      transition-colors
      duration-300
    "
                      >
                        <FaPhoneAlt className="text-lg text-custom-white md:group-hover:text-custom-red" />
                      </div>

                      <span
                        className="
      ml-3
      text-lg
      font-semibold
      text-custom-atrament
      md:group-hover:text-custom-white
      transition-colors
      duration-300
    "
                      >
                        {contact?.contact.mobileConsultancy}
                      </span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="flex flex-col justify-center items-center">
                {" "}
                <p className="title border-l-4 border-custom-red pl-4 sm:pt-0 pt-4 pb-4 3xl:text-xl md:text-lg text-md">
                  V našom sortimente nájdete všetko potrebné náradie a
                  mechanizáciu domácich majstrov ako aj profesionálov v oblasti
                  stavebníctva.
                  <br />
                  Pred samotným prenájmom je potrebné dostupnosť konkrétnych
                  zariadení vždy vopred{" "}
                  <span className="font-semibold md:tracking-wide">
                    preveriť telefonicky
                  </span>
                  .
                </p>
                <div className="flex sm:flex-row flex-col w-full py-3 gap-4 sm:gap-0 lg:justify-start justify-center items-center">
                  <button
                    className="h-[3rem] sm:mr-4 sm:w-48 w-full rounded-lg bg-custom-atrament shadow-lg md:hover:text-custom-white text-custom-gray 
          md:hover:bg-custom-red transition duration-200 ease-in-outt"
                    onClick={() => navigate("/prenajom-zariadeni")}
                  >
                    Pozrieť ponuku
                  </button>
                  <div
                    className="
    flex sm:hidden items-center justify-center gap-3

    before:content-['']
    before:h-[3px]
    before:w-7
    before:rounded-full
    before:bg-custom-blue/30

    after:content-['']
    after:h-[3px]
    after:w-7
    after:rounded-full
    after:bg-custom-blue/30

    sm:before:w-10
    sm:after:w-10

    lg:before:h-[4px]
    lg:before:w-14

    lg:after:h-[4px]
    lg:after:w-14
  "
                  >
                    <span
                      className="
      text-xs
      font-semibold
      uppercase
      tracking-[0.25em]
      text-custom-blue/60
    "
                    >
                      Alebo
                    </span>
                  </div>
                  <button
                    className="h-[3rem] sm:w-48 w-full border-2 border-bg-custom-atrament rounded-lg bg-custom-white text-custom-atrament shadow-lg 
          md:hover:bg-custom-red md:hover:border-custom-red md:hover:text-custom-white transition duration-200 ease-in-out"
                    onClick={() => navigate("/kontakt")}
                  >
                    Prejsť na kontakt
                  </button>
                </div>
              </div>
            </div>
            <div className="flex w-full justify-center items-center">
              {" "}
              <AvailabilitySection
                imageSrc="images/main-content-bg.png"
                contact={contact?.contact.mobileConsultancy}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Contact Form */}
      <ModalComponent modalOpen={modalOpen} closeModal={closeModal} />
    </>
  );
};

export default Home;
